import React, {PropTypes} from 'react';
import Button from "react-bootstrap/lib/Button";
import axios from 'axios';


let cleanString = (string) => {
  string = string.replace(/"/g, "");
  string = string.replace(/\r?\n|\r/, "");
  return string;
};

let cleanStringArray = (arrayOfStrings) => {
  for (let i = 0; i < arrayOfStrings.length; i++) {
    arrayOfStrings[i] = cleanString(arrayOfStrings[i]);
  }
  console.log(arrayOfStrings);
  return arrayOfStrings
};
function validate(csv) {
  let row = csv.split('\n');
  let header = row[0].split(',');
  header = cleanStringArray(header);
  header = header.map((element) => {
    return element.split(' ').join('').toLowerCase();
  });

  return true;
}

function csvJSON(csv) {

  var lines = csv.split("\n");
  var result = [];
  var headers = lines[0].split(",");
  for (var k = 0; k < headers.length; k++) {
    headers[k] = headers[k].replace(/['"]+/g, '');
  }
  console.log(headers);
  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");
    if (currentline[0] == "") {
      currentline[0] = null;
    }
    var date = new Date();
    for (var j = 0; j < headers.length; j++) {
      if (j == headers.length - 1)
        headers[j] = 'rating';
      if (currentline[j] != null)
        if (currentline[j].trim().length == 0) {
          obj[headers[j]] = null;
        }
        else {
          obj[headers[j]] = encodeURI(cleanString(currentline[j]));
        }
      else
        obj[headers[j]]=null;
    }
    result.push(obj);
  }
  return result; //JSON
}


class QCapUpload extends React.Component {

    constructor() {
      super();
      this.state={value: "",requestObject: []}
      this.handleChange = this.handleChange.bind(this);
    }

  handleChange(event) {
    let files = event.target.files;
    if (files.length === 1) {
      let reader = new FileReader();
      reader.onload = function () {
        let csv = reader.result;
        if (validate(csv) === true) {
          let result = (csvJSON(csv));
          result.filter((node)=> {
            if (node.empId == null)
              return false;
            else
              return true;
          });
          this.setState({requestObject: result, length: result.length,disabled: false})
        }
        else {
          alert("Please check the table format of the csv uploaded.")
        }
      }.bind(this);
      if (event.target.value != null || event.target.value == "")
        this.setState({value: event.target.value});
      else
        this.setState({value: ""})
      reader.readAsText(files[0], 'UTF-8');
    }

  }

    render() {
        return (
          <div>
            <input value={this.state.value}
                   type="file" accept=".csv" name="file" onChange={this.handleChange}/>
            <Button
              className="btn-lg"
              disabled={this.state.disabled}
              onClick={()=> {
                console.log(this.state.requestObject);
                axios.post(process.env.REQ_URL + "/qcap/saveQCapRatings",
                  {data: this.state.requestObject},
                  {withCredentials: true ,
                    headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                  this.setState({requestObject: response.data.data, disabled: true, message: "Upload Complete"})

                }).catch((error)=> {

                })
              }}>Upload</Button>
            <h2>{this.state.message}</h2>
            <nav style={{borderStyle: 'solid'}}>
              <br/>
              <ul style={{'overflow': 'hidden', 'overflowY': 'scroll', height: '300px', width: '100%'}}>
                <table className="table table-bordered table-striped">
                  <thead>
                  <tr>
                    <th>empId</th>
                    <th>date ( YYYY-MM-01 )</th>
                    <th>rating</th>
                    <th>Message</th>

                  </tr>
                  </thead>
                  <tbody>
                  {this.state.requestObject.map((node, index)=> {
                    if (node.empId != null)
                      return <tr>
                        <td>{(node.empId)}</td>
                        <td>{(node.date)}</td>
                        <td>{(node.rating)}</td>
                        <td>{node.message}</td>
                      </tr>
                  })}
                  </tbody>
                </table>
              </ul>
            </nav>
          </div>
        );
    }
}

QCapUpload.propTypes = {};

export default QCapUpload;





/** WEBPACK FOOTER **
 ** ./src/feature/hrbp/QCapUpload.js
 **/